<template>
<div class="animated fadeIn">
        <b-card>
          <div slot="header">
            Ubah Data Diri Anda
          </div>
          <div class="container" style="overflow:scroll;">
          <form @submit="onSubmit">
                                <div class="row register-form">
                                    <div class="col-md-6">
                                     
                                        <div class="form-group">
                                          <label>Nama Lengkap</label>
                                            <input type="text"
                                            v-model="inputnya.profile.nama"
                                            class="form-control"
                                            placeholder="Nama Lengkap"  />
                                        </div>
                                        <div class="form-group">
                                          <label>Username</label>
                                            <input type="text" v-model="inputnya.services.username" class="form-control" placeholder="Username"  />
                                        </div>
                                        <!-- <div class="form-group">
                                            <input type="password" v-model="inputnya.services.password.bcrypt" class="form-control" placeholder="Password"  />
                                        </div> -->
                                        <div class="form-group">
                                          <label>Jenis Kelamin</label>
                                            <select class="form-control" v-model="inputnya.profile.gender">
                                                <option  value ="null"
                                                class="hidden"  selected
                                                disabled>Pilih Jenis Kelamin</option>
                                                <option value="L">Laki - Laki</option>
                                                <option value="P">Perempuan</option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                          <label>Email</label>
                                            <input type="email" v-model="inputnya.emails.address" class="form-control" placeholder="Email"/>
                                        </div>
                                        <div class="form-group">
                                          <label>No. Hp</label>
                                            <input type="text"
                                            v-model="inputnya.profile.phone"
                                            minlength="11" maxlength="15"
                                            class="form-control"
                                            placeholder="No. Hp"  />
                                        </div>
                                         <div class="form-group">
                                           <label>Tempat Lahir</label>
                                            <input type="text"
                                            v-model="inputnya.profile.bornplace"
                                            class="form-control"
                                            placeholder="Tempat Lahir"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label>Tanggal Lahir</label>
                                        <div class="form-group">
                                            <input type="date"
                                            v-model="inputnya.profile.bornpdate"
                                            class="form-control"
                                            placeholder="Tanggal Lahir"  />
                                        </div> 
                                        <div class="form-group">
                                          <label>Alamat Lengkap</label>
                                            <textarea class="form-control" v-model="inputnya.profile.address" rows="3" placeholder="Alamat"></textarea>
                                        </div>
                                        <div class="form-group">
                                          <label>Nama Orang Tua</label>
                                            <input type="text"
                                            v-model="inputnya.profile.parent"
                                            class="form-control"
                                            placeholder="Nama Orang Tua"  />
                                        </div>
                                        <div class="form-group">
                                          <label>Telepon Orang Tua</label>
                                            <input type="text"
                                            v-model="inputnya.profile.phoneparent"
                                            minlength="11" maxlength="15"
                                            class="form-control"
                                            placeholder="Telepon Orang Tua"  />
                                        </div>
                                       
                                        <div class="form-group">
                                          <label>Penginapan</label>
                                            <input type="text"
                                            v-model="inputnya.profile.camp"
                                            class="form-control"
                                            placeholder="Penginapan"  />
                                        </div>
                                        
                                    </div>
                                  <input type="submit" class="btn btn-primary" value="Simpan Profil"/>
                                </div>
                                </form>
          </div>
        </b-card>
</div>

</template>

<script>
import { API_SERVER } from "@/config";
import { CALLAPI, CALLAPILOGIN } from "@/functions";
export default {
  name: 'Update Profile',
  data() {
    return {
       inputnya: {
profile :{

          nama: '',
          gender: null,
          phone: '',
          camp: '',
          parent: '',
          phoneparent: '',
          bornplace: '',
          bornpdate: '',
          address: '',

},
services :{
          username: '',
          // password: '',
          password :{
            bcrypt: 'kresna1234'
          }
},
emails : {
          address: '',
}

        },
    };
  },
  mounted(){
  
  },
  methods:{
    getdatatransaksi(){
      let iduser = localStorage.getItem("X-Id");
      // console.log(iduser);
      CALLAPILOGIN.get("transaksi/user/" + iduser)
        .then(response => {
          this.data_transaksi = response.data.data;
          // console.log(response);
        })
        .catch(e => {
          // this.$router.push({ path: "/user/404" })
          this.errors.push(e);
        });
    },
    formatdatelengkap(date) {
      var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ];

      var myDays = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
      ];

      var date = new Date(date);
      var day = date.getDate();
      var month = date.getMonth();
      var thisDay = date.getDay(),thisDay = myDays[thisDay];
      var yy = date.getYear();
      var hour = this.addzero(date.getHours());
      var minute = this.addzero(date.getMinutes());
      var year = yy < 1000 ? yy + 1900 : yy;
      return thisDay + ", " + day + " " + months[month] + " " + year+ " Pukul " + hour+ ":" +minute+" WIB";
    },
    link(id){
      // console.log(id);
      
      this.$router.push({ path: "invoice_transaksi/"+id })
    },
    canceltransaksi(id) {
      swal({
        title: "Are you sure?",
        text: "Apakah Anda Yakin Ingin Membatalkan Transaksi ini?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          CALLAPILOGIN.put("transaksi/cancelbyid/" + id)
            .then(response => {
              this.getdatatransaksi();
              swal("Success Cancel", "Berhasil Membatalkan Transaksi!", {
                icon: "success"
              });
            })
            .catch(e => {
              swal("Failed Cancel", "Gagal Membatalkan Transaksi!", {
                icon: "error"
              });
              this.errors.push(e);
            });
        }
      });
    },
  }
}
</script>
